import axios from "axios"
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import configData from "config.json"
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { InformacionGeneralProyectosInstitucionales, HistorialProyectosInstitucionales, PostProyectosInstitucionales } from "./TypesProyectosInstitucionales";

export async function ObtenerProyectosInstitucionales(handleError: (info?: any) => void) {
    const url = `${configData.SERVER_URL}ProyectosInstitucionales/InformacionGeneral`;
    var userData: UserData = authenticationService.currentUserValue;
    var datos: Array<any> | undefined = undefined;

    var informaciongeneral: InformacionGeneralProyectosInstitucionales = {
        tiposAmbito: [],
        tiposFuncion: [],
        tiposTermino: [],
        estructuraorganica: [],
        periodosacademicos: [],
        unidad: "",
        idunidad: 0,
        anio: -1
    }

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: informaciongeneral }
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithToken(userData.token),
        })

        informaciongeneral = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse: informaciongeneral,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = {
                status: error.response.status,
                dataResponse: datos,
                errorMessage: error.response.data ?? ""
            }
            handleError(respuestaResponse.errorMessage);
        }
        else {
            handleError();
        }
    }
    return respuestaResponse;
}

export async function ObtenerProyectoInstitucional(id: number) {
    var datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/ProyectoInstitucionalById/" + id
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithToken(datosUsuario.token),
        })

        respuestaResponse = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }
        }
    }
    return respuestaResponse;
}

export async function ObtenerDetalleHistorial(anio: number) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/DetalleHistorial/" + anio
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithToken(datosUsuario.token)
        })

        respuestaResponse = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status }
        }
    }
    return respuestaResponse;
}

export async function ObtenerAniosHistorial() {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/HistorialSolicitudes/AniosDisponibles"
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithUserData(datosUsuario)
        })
        const datos: number[] = respuesta.data;

        respuestaResponse = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return respuestaResponse;
}

export async function ObtenerHistorial(anio: number) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/HistorialSolicitudes/" + anio
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithUserData(datosUsuario)
        })
        const datos: HistorialProyectosInstitucionales[] = respuesta.data;

        respuestaResponse = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return respuestaResponse;
}

export async function GuardarSolicitudProyectosInstitucionales(formData: FormData) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/GuardarProyectoInstitucional"
    try {
        const respuesta = await axios.post(url, formData,
            {
                headers: authHeaderWithToken(datosUsuario.token),
            }
        )

        respuestaResponse = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }

        }
    }
    return respuestaResponse
}

export async function ProyectosInstitucionalesVistaPrevia(solicitud: PostProyectosInstitucionales) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/VistaPreviaDocumento"
    try {
        const respuesta = await axios.post(url, solicitud,
            {
                headers: authHeaderWithToken(datosUsuario.token),
                responseType: "blob"
            }
        )

        const blob_resource = await respuesta.data;
        const url_documento = window.URL.createObjectURL(blob_resource);
        respuestaResponse = { status: respuesta.status, dataResponse: url_documento }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
        else if (axios.isAxiosError(error) && !error.response) {
            respuestaResponse = { status: -1, errorMessage: "No ha sido posible contactar con el servidor. Intente más tarde." }
        }
    }
    return respuestaResponse
}

export async function AnularSolicitud(idSolicitud: number, observacion: string) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/Anularsolicitud/" + idSolicitud;
    try {
        const respuesta = await axios.post(url, {},
            {
                headers: authHeaderWithToken(datosUsuario.token),
            }
        )

        respuestaResponse = { status: respuesta.status }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }

        }
    }
    return respuestaResponse
}

export async function ObtenerVistaPreviaDocumento(idSolicitud: number) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var urlVistaPrevia = "";
    const url = configData.SERVER_URL + "ProyectosInstitucionales/VistaPreviaDocumento/" + idSolicitud;
    try {
        const respuesta = await fetch(configData.SERVER_URL + url, {
            method: 'GET',
            headers: authHeaderWithToken(datosUsuario.token),

        })
        if (respuesta.ok) {
            const archivo = await respuesta.blob()
                .then(archivo => {
                    urlVistaPrevia = window.URL.createObjectURL(archivo);
                });
        }
    } catch (error) {
        /*if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }

        }*/
    }
    return urlVistaPrevia
}

export async function GuardarSolicitudProyectosInstitucionalesFirmada(formData: FormData) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/GuardarProyectoInstitucionalFirmada"
    try {
        const respuesta = await axios.post(url, formData,
            {
                headers: authHeaderWithToken(datosUsuario.token),
            }
        )

        respuestaResponse = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }

        }
    }
    return respuestaResponse
}

export async function ObtenerAniosHistorialAutoridad() {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/HistorialSolicitudesAutoridad/AniosDisponibles"
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithUserData(datosUsuario)
        })
        const datos: number[] = respuesta.data;

        respuestaResponse = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return respuestaResponse;
}

export async function ObtenerHistorialAutoridad(anio: number) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/HistorialSolicitudesAutoridad/" + anio
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithUserData(datosUsuario)
        })
        const datos: HistorialProyectosInstitucionales[] = respuesta.data;

        respuestaResponse = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return respuestaResponse;
}

export async function AnularSolicitudAutoridad(idSolicitud: number, observacion: string) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/AnularSolicitudAutoridad/" + idSolicitud;
    try {
        const respuesta = await axios.post(url, observacion,
            {
                headers: authHeaderWithToken(datosUsuario.token),
            }
        )

        respuestaResponse = { status: respuesta.status }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }

        }
    }
    return respuestaResponse
}

export async function GuardarSolicitudProyectosInstitucionalesAutoridad(formData: FormData) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/GuardarProyectoInstitucionalAutoridad"
    try {
        const respuesta = await axios.post(url, formData,
            {
                headers: authHeaderWithToken(datosUsuario.token),
            }
        )

        respuestaResponse = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }

        }
    }
    return respuestaResponse
}

export async function ProyectosInstitucionalesVistaPreviaAutoridad(solicitud: PostProyectosInstitucionales) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/VistaPreviaDocumentoAutoridad"
    try {
        const respuesta = await axios.post(url, solicitud,
            {
                headers: authHeaderWithToken(datosUsuario.token),
                responseType: "blob"
            }
        )

        const blob_resource = await respuesta.data;
        const url_documento = window.URL.createObjectURL(blob_resource);
        respuestaResponse = { status: respuesta.status, dataResponse: url_documento }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
        else if (axios.isAxiosError(error) && !error.response) {
            respuestaResponse = { status: -1, errorMessage: "No ha sido posible contactar con el servidor. Intente más tarde." }
        }
    }
    return respuestaResponse
}

export async function GuardarSolicitudProyectosInstitucionalesFirmadaAutoridad(formData: FormData) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/GuardarProyectoInstitucionalFirmadaAutoridad"
    try {
        const respuesta = await axios.post(url, formData,
            {
                headers: authHeaderWithToken(datosUsuario.token),
            }
        )

        respuestaResponse = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }

        }
    }
    return respuestaResponse
}

export async function ObtenerAniosHistorialConsultor() {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/HistorialSolicitudesConsultor/AniosDisponibles"
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithUserData(datosUsuario)
        })
        const datos: number[] = respuesta.data;

        respuestaResponse = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return respuestaResponse;
}

export async function ObtenerHistorialConsultor(anio: number) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/HistorialSolicitudesConsultor/" + anio
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithUserData(datosUsuario)
        })
        const datos: HistorialProyectosInstitucionales[] = respuesta.data;

        respuestaResponse = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return respuestaResponse;
}

export async function ObtenerNombreTitulo(id: number) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/GetNombreApellidosTitulo/" + id
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithUserData(datosUsuario)
        })

        respuestaResponse = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return respuestaResponse;
}

export async function EliminarSolicitudAutoridad(idSolicitud: number, observacion: string) {
    const datosUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "ProyectosInstitucionales/EliminarsolicitudAutoridad/" + idSolicitud;
    try {
        const respuesta = await axios.post(url, observacion,
            {
                headers: authHeaderWithToken(datosUsuario.token),
            }
        )

        respuestaResponse = { status: respuesta.status }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }

        }
    }
    return respuestaResponse
}